export const MasterNames = {
  AREATYPE: "Area Type Master",
  DISTRICT: "District Master",
  TALUKA: "Taluka Master",
  PHC: "Phc Master",
  UPHC: "Urban Phc Master",
  SUBCENTER: "Sub Center Master",
  VILLAGE: "Village Master",
  SUBAREA: "Sub Area Master",
  ROLE: "Role Master",
  USER: "User Master",
  BANK: "Bank Master",
  BANK_BRANCH: "Bank Branch Master",
  TRAINING: "Training Master",
  FACULTY: "Faculty Master",
  TRAINING_CALENDAR: "Training Calendar Master",
  PROGRAM: "Program Master",
  SCHEME: "Scheme Master",
  ACTIVITY: "Activity Master",
  GOVERNINGBODY: "Governing Body Master",
  CORPORATION: "Corporation Council Master",
};

export const MasterCategoryNames = {
  LOCATION: "Location Related List",
  BANK: "Bank Related List",
  USER: "User Related List",
  TRAINING: "Training Related List",
  SCHEME: "Scheme Related List",
};
